import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ExecuteContactCleanupRequest,
  WhatsappContactCleanupCounts,
  WhatsappContactCleanupResult,
} from '../models/whatsapp.model';

/**
 * Limpieza de los contactos que WhatsApp creó solo mientras el alta automática estuvo
 * encendida.
 *
 * Ninguno de los dos endpoints acepta `businessId`: sale del JWT a propósito, para que un
 * negocio no pueda previsualizar ni borrar los contactos de otro.
 */
@Injectable({ providedIn: 'root' })
export class WhatsappContactCleanupApiService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}api/whatsapp/contact-cleanup`;

  /** Sólo lectura e idempotente: no borra nada, se puede llamar las veces que haga falta. */
  preview(): Observable<WhatsappContactCleanupCounts> {
    return this.http.get<WhatsappContactCleanupCounts>(`${this.base}/preview`);
  }

  /**
   * IRREVERSIBLE. `expectedContacts` tiene que ser el `contacts` de la previsualización: el
   * backend lo recuenta dentro de la misma transacción y responde 409 sin borrar nada si el
   * conjunto cambió mientras tanto (entraron mensajes nuevos).
   */
  execute(req: ExecuteContactCleanupRequest): Observable<WhatsappContactCleanupResult> {
    return this.http.post<WhatsappContactCleanupResult>(this.base, req);
  }
}
